// src/pages/Login/LoginController.ts
import {useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {login} from '../../services/api'

export const useLoginController = () => {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [showPassword, setShowPassword] = useState(false)

    const navigate = useNavigate()

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setLoading(true)
        setError('')

        try {
            const res = await login(username, password)

            if (res.success) {
                navigate('/dashboard', {replace: true})
            } else {
                setError(res.message || 'فشل تسجيل الدخول')
            }
        } catch (err: any) {
            setError(err.response?.data?.error || err.message || 'حدث خطأ في الاتصال')
        } finally {
            setLoading(false)
        }
    }

    return {
        // State
        username,
        password,
        loading,
        error,
        showPassword,

        // Setters
        setUsername,
        setPassword,
        setShowPassword,

        // Actions
        handleSubmit
    }
}